import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CopyRightInfo from "../../core/common/copyRightInfo";
import HeaderLogo from "../../core/common/headerLogo";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { 
  setAuthToken, 
  setRefreshAuthToken, 
  setTenantID , 
  setRememberMe as storeRememebrMe, 
  getRememberMe,
  toDateFromEpoch
} from "../../common/Utils";
import useFetch from "../../hooks/useFetch";
import { useAuthTenant } from "../../hooks/useAuthTenant";
import { API } from "../../common/Constants";
import { useAuth } from "../../hooks/authContext";
import PreLoader from "../../core/common/preLoader";

type PasswordField = "password" | "confirmPassword";

const Register = () => {
  const routes = all_routes;
  const {setAuthUser, setIsLoggedIn} = useAuth();
  const navigation = useNavigate();
  const {
    tenant,
    setTenant,
    setTenantResolved,
    hideTenantInput,
  } = useAuthTenant();
  const [tenantInfo, setTenantInfo] = useState<{
    institutionName: string;
    institutionLogo: string;
  } | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [rememberMe, setRememberMe]  = useState<boolean>(false || getRememberMe());
  const { callFetch } = useFetch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [userData, setUserData] = useState<{
    username: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: number | undefined;
    dateOfBirth: number | undefined;
    gender: string;
  }>({
    username: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: undefined,
    dateOfBirth: undefined,
    gender: '',
  });

  useEffect(() => {
    if (tenant) {
      fetchTenantInfo();
    } else {
      setTenantResolved(false);
      setTenantInfo(null);
    }
  }, [tenant]);

  const fetchTenantInfo = async () => {
    if (!tenant) {
      setTenantResolved(false);
      setTenantInfo(null);
      return;
    }
    setTenantResolved(false);
    callFetch(
      API.TENANT_INFO.replace(':tenantId', tenant),
      'GET',
      {'X-Tenant-ID': tenant},
      null,
      null
    ).then((response) => {
      if (response && response.settingGroups) {
        const brandingGroup = response.settingGroups.find(
          (group: any) => group.category === 'BRANDING'
        );
        
        if (brandingGroup && brandingGroup.settings) {
          const institutionNameSetting = brandingGroup.settings.find(
            (setting: any) => setting.settingKey === 'institution_name'
          );
          const institutionLogoSetting = brandingGroup.settings.find(
            (setting: any) => setting.settingKey === 'institution_logo'
          );
          
          setTenantInfo({
            institutionName: institutionNameSetting?.currentValue || 'Institution',
            institutionLogo: institutionLogoSetting?.currentValue || ''
          });
        } else {
          setTenantInfo(null);
        }
        setTenantResolved(true);
      } else {
        setTenantInfo(null);
        setTenantResolved(false);
      }
    }).catch((error) => {
      console.error('Failed to fetch tenant info:', error);
      setTenantInfo(null);
      setTenantResolved(false);
    });
  };

  const validateForm = () => {
    // if (!userData.username.trim()) {
    //   setErrorMessage("Please enter username");
    //   return false;
    // }
    if (!userData.phoneNumber || userData.phoneNumber.toString().length !== 10) {
      setErrorMessage("Please enter valid 10 digit phone number");
      return false;
    }
    if (!userData.password.trim()) {
      setErrorMessage("Please enter password");
      return false;
    }
    if (userData.password !== userData.confirmPassword) {
      setErrorMessage("Passwords do not match");
      return false;
    }
    if (!userData.firstName.trim()) {
      setErrorMessage("Please enter first name");
      return false;
    }
    if (!userData.lastName.trim()) {
      setErrorMessage("Please enter last name");
      return false;
    }
    // if (!userData.email.trim()) {
    //   setErrorMessage("Please enter email");
    //   return false;
    // }

    // if (!userData.dateOfBirth) {
    //   setErrorMessage("Please select date of birth");
    //   return false;
    // }
    // if (!userData.gender) {
    //   setErrorMessage("Please select gender");
    //   return false;
    // }
    return true;
  };

  const handleSignup = async () => {
    if (!validateForm()) {
      return;
    }

    setErrorMessage("");
    setIsLoading(true);

    const payload = {
        // username: userData.username.trim(),
        password: userData.password,
        phoneNumber: userData.phoneNumber,
        firstName: userData.firstName.trim(),
        lastName: userData.lastName.trim(),
        // dob: userData.dateOfBirth ? userData.dateOfBirth / 1000 : undefined,
        // gender: userData.gender,
        // email: userData.email.trim(),
        isCommercialUser: true,
    };

    callFetch(API.SIGNUP,
      "POST", { "X-Tenant-ID": tenant }, null, payload)
      .then((response) => {
        setIsLoading(false);
        setAuthUser(userData.username);
        setIsLoggedIn(true);
        reset();
        onSuccess(response);
      }).catch((error: any) => {
        setIsLoading(false);
        setErrorMessage(error?.response?.data || "Signup failed. Please try again.");
      }) ;
  };

  
  const reset = () => {
    setUserData({
      ...userData,
      username: '',
      password: '',
      confirmPassword: '',
      dateOfBirth: undefined,
    })
  }

  const onSuccess = (data:any) => {
    setAuthToken(data?.token)  
    if(rememberMe){
      storeRememebrMe(true);
      setRefreshAuthToken(data?.refreshToken)
    } else{
      storeRememebrMe(false);
    }
    setTenantID(tenant)
    navigation(routes.index)
  };

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  return (
    <div className="container-fuild">
      <PreLoader showLoader={isLoading} />
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-02.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-7 mx-auto vh-100">
                <form action="login-2.html" className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <HeaderLogo 
                        url={tenantInfo?.institutionLogo}
                        name={tenantInfo?.institutionName}
                        size="L"
                      />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Sign Up</h2>
                        <p className="mb-0">Please enter your details to sign up</p>
                      </div>
                      {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}
                      <div className="mb-3" hidden={hideTenantInput}>
                        <label className="form-label">Tenant ID</label>
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Tenant ID"
                            className="form-control border-end-0"
                            onChange={(e)=>setTenant(e.target.value)} value={tenant || ""}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-building" />
                          </span>
                        </div>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">User Name</label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e)=>setUserData({...userData, username: e.target.value})} 
                            value={userData.username}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                      </div> */}
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e)=>setUserData({...userData,
                               phoneNumber: parseInt(e.target.value) || undefined})} 
                            value={userData.phoneNumber}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-phone" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.password
                                ? "text"
                                : "password"
                            }
                            className="pass-input form-control"
                            onChange={(e)=>setUserData({...userData, password: e.target.value})} 
                            value={userData.password}
                          />
                          <span
                            className={`ti toggle-passwords ${passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                              }`}
                            onClick={() =>
                              togglePasswordVisibility("password")
                            }
                          ></span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.confirmPassword
                                ? "text"
                                : "password"
                            }
                            className="pass-input form-control"
                            onChange={(e)=>setUserData({...userData, confirmPassword: e.target.value})} 
                            value={userData.confirmPassword}
                          />
                          <span
                            className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                              ? "ti-eye"
                              : "ti-eye-off"
                              }`}
                            onClick={() =>
                              togglePasswordVisibility("confirmPassword")
                            }
                          ></span>
                        </div>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">Date of Birth</label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker"
                            format={{
                              format: "DD-MM-YYYY",
                              type: "mask",
                            }}
                            placeholder="DD-MM-YYYY"
                            value={
                              userData.dateOfBirth
                                ? dayjs(toDateFromEpoch(userData.dateOfBirth))
                                : undefined
                            }
                            onChange={(dt) => {
                              setUserData({
                                ...userData,
                                dateOfBirth: dt?.toDate()?.getTime(),
                              });
                            }}
                            disabledDate={(current) => {
                              // Disable all future dates - date should not be greater than today
                              return current && current.isAfter(dayjs(), 'day');
                            }}
                          />
                        </div>
                      </div> */}
                      <div className="mb-3">
                        <label className="form-label">FirstName</label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e)=>setUserData({...userData, firstName: e.target.value})} 
                            value={userData.firstName}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e)=>setUserData({...userData, lastName: e.target.value})} 
                            value={userData.lastName}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">Email Address</label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e)=>setUserData({...userData, email: e.target.value})} 
                            value={userData.email}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div> */}
                      {/* <div className="mb-3">
                        <label className="form-label">Gender</label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="gender_male"
                              value="M"
                              checked={userData.gender === "M"}
                              onChange={(e) => setUserData({...userData, gender: e.target.value})}
                            />
                            <label className="form-check-label" htmlFor="gender_male">
                              Male
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="gender_female"
                              value="F"
                              checked={userData.gender === "F"}
                              onChange={(e) => setUserData({...userData, gender: e.target.value})}
                            />
                            <label className="form-check-label" htmlFor="gender_female">
                              Female
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="gender_other"
                              value="O"
                              checked={userData.gender === "O"}
                              onChange={(e) => setUserData({...userData, gender: e.target.value})}
                            />
                            <label className="form-check-label" htmlFor="gender_other">
                              Other
                            </label>
                          </div>
                        </div>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <div className="form-check form-check-md mb-0">
                            <input
                              className="form-check-input"
                              id="remember_me"
                              type="checkbox"
                              onChange={(e)=>setRememberMe(e.target.checked)}
                              checked={rememberMe}
                            />
                            <label
                              htmlFor="remember_me"
                              className="form-check-label mt-0"
                            >
                              Remember Me{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <button type="button" onClick={handleSignup} className="btn btn-primary w-100">
                          Sign Up
                        </button>
                      </div>
                      <div className="text-center">
                        <h6 className="fw-normal text-dark mb-0">
                          Already have an account?
                          <Link to={all_routes.login} className="hover-a ms-1">
                            Sign In
                          </Link>
                        </h6>
                      </div>
                    </div>
                    <div className="mt-5 pb-4 text-center">
                      <CopyRightInfo />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Register;